/** 权限对应的菜单 */
let map = {
  'doctor:exam:evaluate': [{title: '测试分析', path: '/doctor/test/list/new', sort: 5}],
  'doctor:appoint': [
    {title: '用户管理', path: '/doctor/patients', sort: 4},
    {title: '预约管理', path: '/doctor/reservation', sort: 10},
    {title: '优惠券管理', path: '/doctor/coupon', sort: 8},
    {title: '咨询历史', path: '/doctor/medicalRecord', sort: 6}],
  'doctor:article:research': [{title: '文章管理', path: '/doctor/articles', sort: 3}],
  'doctor:article:information': [{title: '文章管理', path: '/doctor/articles', sort: 3}],
  'doctor:article:science': [{title: '文章管理', path: '/doctor/articles', sort: 3}],
};


let none_map = [
  {title: '首页', path: '/index', sort: 0},
  {title: '主页', path: '/workbench/', sort: 1},
  {title: 'banner管理', path: '/doctor/banner', sort: 2},
  {title: '结账单', path: '/doctor/checkOut', sort: 7},
  //{title: '账号管理', path: '/doctor/account', sort: 10} 原个人主页展示
  // {title: '账号管理', path: '/doctor/info', sort: 9}, 移动至下拉框
  {title: '帮助中心', path: '/doctor/doctorHelp', sort: 11},
];


/**
 * 根据权限返回对应的菜单
 * @param permissions
 * @returns [{},{}...]
 */
function getMenuByPermissions(permissions) {
  if (!Array.isArray(permissions)) {
    throw new Error("permissions error: not a array type.");
  }
  let permissionLength = permissions.length;
  let menus = new Array(0);
  for (let i = 0; i < permissionLength; i++) {
    let menu = map[$.trim(permissions[i])];
    if (menu) {
      menus.push(...menu);
    }
  }
  // none-map处理
  menus.push(...none_map);
  // 重新调整顺序
  menus.sort((a, b) => a.sort - b.sort);

  // 去重处理: 主要处理文章管理部分
  let finalMenus = [];
  for (let j = 0; j < menus.length; j++) {
    let curMenu = menus[j];
    let nextMenu = menus[j + 1];
    if (!nextMenu) {
      finalMenus.push(curMenu);
      continue;
    }
    if (curMenu.title == nextMenu.title) {
      continue;
    }
    finalMenus.push(curMenu);
  }
  return finalMenus;
}

export default {
  getMenuByPermissions
}
